export function stickyCardsAnchors() {
	
	const $link = $(".sticky-cards .anchors a");
	const $html = $("html, body");
	const $body = $("body");
	const $header = $(".header");
	
	$link.on("click", function (evt) {
		evt.preventDefault();
		if ( $body.hasClass("touch") ) {
			$html.stop().animate({scrollTop: $(`${$(this).attr("href")}`).offset().top - $header.height()}, 700, 'swing');
		}
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/sticky-cards-anchors.js